import { Modal, Button, Select } from '@/components/ui'
import type { RegistrationField } from '@/pages/events/attendees/types'

interface ColumnMappingModalProps {
  open: boolean
  onClose: () => void
  columnHeader: string
  currentMapping: string | null | undefined
  registrationFields: RegistrationField[]
  usedMappings: string[]
  onMappingChange: (fieldIdentifier: string | null) => void
}

export default function ColumnMappingModal({
  open,
  onClose,
  columnHeader,
  currentMapping,
  registrationFields,
  usedMappings,
  onMappingChange,
}: ColumnMappingModalProps) {
  const handleFieldSelect = (value: string) => {
    onMappingChange(value || null)
  }

  const handleDiscard = () => {
    onMappingChange(null)
  }

  // Build options for the select
  const fieldOptions = registrationFields.map((field) => {
    const isUsed = usedMappings.includes(field.identifier) && field.identifier !== currentMapping
    return {
      value: field.identifier,
      label: (
        <span style={isUsed ? { color: '#9ca3af' } : undefined}>
          {field.label}
          {field.required && <span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>}
          {isUsed && <span style={{ color: '#9ca3af', marginLeft: '8px' }}>(already mapped)</span>}
        </span>
      ),
      disabled: isUsed,
    }
  })

  return (
    <Modal
      title={`Map column: ${columnHeader}`}
      open={open}
      onClose={onClose}
      width={480}
      footer={null}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: 500, color: '#374151', marginBottom: '4px' }}>
            Map to registration field
          </label>
          <Select
            style={{ width: '100%' }}
            placeholder="Select a field..."
            value={currentMapping || undefined}
            onChange={handleFieldSelect}
            options={fieldOptions}
            allowClear
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
          <Button variant="tertiary" onClick={handleDiscard}>
            Discard this column
          </Button>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button variant="tertiary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onClose}>
              Done
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
